export default __webpack_public_path__ + "static/media/img_1.22f7427c.JPG";